"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Check } from "lucide-react";
export default function StructuralSteelExpertise() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.15,
    rootMargin: "0px"
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2,
    rootMargin: "-50px"
  });
  return <section ref={sectionRef} className="relative min-h-screen bg-dark-background py-20 px-4 sm:px-6 lg:px-8 overflow-hidden" aria-label="Structural steel expertise section">
      {}
      <div className="absolute inset-0 opacity-100 brightness-150 bg-cover bg-center bg-[url(https://romeroweldinginc.com/wp-content/uploads/2025/11/rwi2.jpg)] pointer-events-none" role="img" aria-label="Structural steel construction project showcasing industrial welding expertise" />
    </section>;
}